import React from "react";

export default function UserDataDeletionPage() {
  return (
    <div className="bg-white text-gray-800">
      {/* Navbar */}
   

      {/* Main Section */}
      <main className="max-w-4xl mx-auto  mt-20 px-5 py-10">
        <h2 className="text-2xl font-bold text-center mb-4">Account Deletion Request</h2>
        <p className="text-sm text-gray-600 mb-6">Last Updated: 17.09.2024 (v1.0)</p>

        <p className="mb-4">
          At Cruze, we value your privacy and are committed to serving you better by storing essential information to improve your experience.
        </p>

        <section className="mb-6">
          <h3 className="text-xl font-semibold mb-2">Information We Store:</h3>
          <ul className="list-disc list-inside space-y-1">
            <li><strong>Phone Number:</strong> Used as your username and for authentication purposes.</li>
            <li><strong>Full Name:</strong> For personalized interactions and service.</li>
            <li><strong>Email Address:</strong> Used for password recovery, account recovery, and sending trip invoices.</li>
            <li><strong>Contacts:</strong> A single emergency contact number for safety during trips.</li>
            <li><strong>Location:</strong> For finding nearby drivers and tracking trips. Route details are deleted post-trip except start/end points.</li>
          </ul>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold mb-2">Requesting Account Deletion:</h3>
          <ol className="list-decimal list-inside space-y-2">
            <li>
              <strong>Submit a Request:</strong> Email us at <a href="mailto:admin@cruze.asia" className="text-blue-600">admin@cruze.asia</a>. We appreciate a short note about why you’re deleting your account.
            </li>
            <li><strong>Processing Time:</strong> Requests are processed within 10 business working days.</li>
            <li><strong>Verification:</strong> We verify your identity before final deletion.</li>
          </ol>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold mb-2">Data Deleted:</h3>
          <ul className="list-disc list-inside space-y-1">
            <li>User details like phone, name, email, and emergency contact.</li>
            <li>Trip history and trips created by the user.</li>
            <li>User settings and preferences.</li>
          </ul>
        </section>

        <section>
          <h3 className="text-xl font-semibold mb-2">Data Retained:</h3>
          <p className="mb-2">
            We retain the unique identification number for accounting and reconciliation due to payment and trip dependencies.
          </p>
          <p>
            For any questions, contact us at <a href="mailto:admin@cruze.asia" className="text-blue-600">admin@cruze.asia</a>.
          </p>
        </section>
      </main>

      {/* Footer */}
      {/* <footer className="bg-black text-white px-6 py-10 text-sm">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <img
              src="/img/tourPackages/Cruze.webp"
              alt="Download App"
              className="w-40"
            />
            <p className="mt-2">Scan to Download Our App!</p>
          </div>

          <div>
            <h5 className="text-lg font-bold mb-2">Useful Links</h5>
            <ul className="space-y-2">
              <li><a href="https://cruze.asia" className="hover:underline">Home</a></li>
              <li><a href="RefundPolicy.html" className="hover:underline">Refund Policy</a></li>
              <li><a href="PricingPolicy.html" className="hover:underline">Pricing Policy</a></li>
              <li><a href="TermsandCond.html" className="hover:underline">Terms & Condition</a></li>
              <li><a href="PrivacyPolicy.html" className="hover:underline">Privacy Policy</a></li>
              <li><a href="UserDataDeletion.html" className="hover:underline">Data Deletion</a></li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-bold mb-2">Contact Us</h5>
            <p>12th Floor, Unit No. 25, Building No.9, Tower B, DLF Cyber City, Phase III, GURGAON - 122002, Haryana, India.</p>
            <p className="mt-1">admin@cruze.asia</p>
            <h6 className="mt-4 font-semibold">Newsletter</h6>
            <p>Stay updated with the latest news from WMD Services India Pvt. Ltd.</p>
            <a href="https://wmdservices.asia/" className="inline-block mt-2 px-4 py-2 bg-white text-black rounded hover:bg-gray-300">
              Visit WMD Services
            </a>
          </div>
        </div>
      </footer> */}

      {/* Back to Top */}
     
    </div>
  );
}